import { render, staticRenderFns } from "./newPaymentModelDetail.vue?vue&type=template&id=17079c6c&scoped=true&"
import script from "./newPaymentModelDetail.vue?vue&type=script&lang=js&"
export * from "./newPaymentModelDetail.vue?vue&type=script&lang=js&"
import style0 from "./newPaymentModelDetail.vue?vue&type=style&index=0&id=17079c6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17079c6c",
  null
  
)

export default component.exports